<template>
  <el-card v-loading="loading" shadow="hover">
    <div style="padding: 10px 20px">
      <div v-if="editModel">
        <el-form
          ref="form"
          :size="$xUISize"
          :model="editModel"
          :rules="editRules"
          @submit.native.prevent
          label-width="auto"
          label-position="top"
        >
          <el-form-item label="供货单位名称" prop="name">
            <el-input
              placeholder="请输入供货单位名称"
              v-model="editModel.name"
            ></el-input>
          </el-form-item>
          <el-form-item label="公司名称" prop="companyName">
            <el-input
              maxlength="128"
              v-model="editModel.companyName"
              placeholder="请输入公司名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="公司地址" prop="companyAddress">
            <el-input
              type="textarea"
              v-model="editModel.companyAddress"
              :rows="2"
              maxlength="512"
              placeholder="输入公司地址信息"
            ></el-input>
          </el-form-item>
          <el-form-item label="联系人姓名" prop="contactsName">
            <el-input
              maxlength="128"
              v-model="editModel.contactsName"
              placeholder="请输入联系人姓名"
            ></el-input>
          </el-form-item>
          <el-form-item label="联系人电话" prop="contactsTelephone">
            <el-input
              maxlength="128"
              v-model="editModel.contactsTelephone"
              placeholder="请输入联系人电话"
            ></el-input>
          </el-form-item>
          <el-form-item label="证照信息" prop="credentials">
            <x-upload
              type="image"
              imageAlign="start"
              :fileCount="10"
              :fileSize="5 * 1024"
              :imageViewWidth="240"
              :imageViewHeight="180"
              v-model="editModel.credentials"
            ></x-upload>
          </el-form-item>
          <el-form-item label="其他选项" prop="moreExtras">
            <div class="borderBox">
              <el-checkbox
                v-model="editModel.optDefault"
                :true-label="1"
                :false-label="0"
              >
                默认供货单位
              </el-checkbox>
              <el-checkbox
                v-model="editModel.optVet"
                :true-label="1"
                :false-label="0"
              >
                兽药资质审核通过
              </el-checkbox>
              <div style="margin-top: 20px">
                <span>
                  选项说明：
                  <li>
                    <strong>默认供货单位</strong>
                    <span> 默认供货单位 </span>
                  </li>
                  <li>
                    <strong>兽药资质审核通过</strong>
                    <span> 已完成对该供货单位的兽药经营资质审核 </span>
                  </li>
                </span>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="排序编号" prop="optSort">
            <el-input
              type="number"
              v-model="editModel.optSort"
              placeholder="请输入排序编号"
              style="width: 100%"
            />
          </el-form-item>
          <el-form-item label="备注说明" prop="optRemark">
            <el-input
              type="textarea"
              v-model="editModel.optRemark"
              :rows="4"
              maxlength="256"
              placeholder="输入备注说明内容"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              :loading="editSubmit"
              @submit.native.prevent
              @click="submitClick"
            >
              保存
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <el-empty v-else-if="!loading" :description="errorMsg" :image-size="100">
        <el-button v-if="errorMsg" @click="fetchModel" size="small">
          重新加载
        </el-button>
      </el-empty>
    </div>
  </el-card>
</template>

<style lang="less" scoped>
.borderBox {
  border-radius: 4px;
  border: 1px solid #dedede;
  padding: 20px;

  &:hover {
    border: 1px solid #cecece;
  }
}
</style>

<script>
const defaultModel = {
  companyName: "",
  companyAddress: "",
  optVet: 0,
  optStatus: 1
}

export default {
  props: {
    params: {
      type: Object,
      default: () => ({}),
    },
    query: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    pageParams() {
      return Object.assign(
        {},
        (this.$route && this.$route.params) || {},
        this.params
      );
    },
    pageQuery() {
      return Object.assign(
        {},
        (this.$route && this.$route.query) || {},
        this.query
      );
    },
  },
  data() {
    return {
      loading: false,
      errorMsg: null,
      editSubmit: false,
      editModel: null,
      editRules: {
        name: [
          {
            required: true,
            message: "请输入供货单位名称",
            trigger: "change",
          },
        ],
      },
    };
  },
  methods: {
    submitClick() {
      this.$refs.form.validate((valid, data) => {
        if (valid) {
          this.editSubmit = true;
          const method = this.editModel.guid
            ? "biz.customer.supplier.info.update"
            : "biz.customer.supplier.info.create";
          this.requestApi(method, this.editModel, {
            showError: true
          }).then((resp) => {
            this.success("保存成功");
            this.$drawer.refreshDrawer();
            this.$drawer.backDrawer();
          }).finally(() => {
            this.editSubmit = false;
          });
        } else {
          this.showValidate(data);
        }
      });
    },
    handleModel() {
      // nothing
      if (this.pageParams.storeGuid) {
        this.editModel.storeGuid = this.pageParams.storeGuid;
      }
    },
    fetchModel() {
      const guid = this.pageParams.guid;
      if (!guid) {
        // 新增
        this.editModel = Object.assign({}, defaultModel);
        this.handleModel();
      } else {
        // 编辑
        this.errorMsg = null;
        this.loading = true;
        this.requestApi("biz.customer.supplier.info.detail", {
          guid: this.pageParams.guid,
          storeGuid: this.pageParams.storeGuid
        }).then((resp) => {
          this.editModel = resp.data;
          this.handleModel();
        }).catch((err) => {
          this.errorMsg = (err && err.msg) || (err && err.message) || "连接服务器失败，请检查网络";
        }).finally(() => {
          this.loading = false;
        });
      }
    },
  },
  mounted() {
    this.fetchModel();
  },
};
</script>
